import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { APP_CONFIG, LanguageService } from './core';
import { UserService } from './services';
import { ConfirmationComponent } from './shared';


@Injectable({ providedIn: 'root' })
export class UserProductGuard implements CanActivate {

	private readonly modalSrv = inject(NgbModal);
	private readonly config = inject(APP_CONFIG);
	private readonly userSrv = inject(UserService);
	private readonly langSrv = inject(LanguageService);


	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return combineLatest([this.userSrv.hasFitboneGrant(), this.langSrv.isLabelsLoaded]).pipe(
			filter(([hasFitboneGrant, isLabelsLoaded]) => isLabelsLoaded),
			tap(([hasFitboneGrant, isLabelsLoaded]) => !hasFitboneGrant && this.openUnauthorizedModal()),
			map(([hasFitboneGrant, isLabelsLoaded]) => hasFitboneGrant)
		);
	}

	private openUnauthorizedModal(): void {
		const modalRef: NgbModalRef = this.modalSrv.open(ConfirmationComponent, { centered: true, backdrop: 'static' });
		(modalRef.componentInstance as ConfirmationComponent).config = {
			title: this.langSrv.labels().USER_UNAUTHORIZED_MODAL_TITLE,
			message: this.langSrv.labels().USER_UNAUTHORIZED_MODAL_MESSAGE,
			confirmBtn: this.langSrv.labels().USER_UNAUTHORIZED_MODAL_CONFIRM_BTN,
			isCancelBtn: false
		};
		modalRef.result.then(() => globalThis.location.href = this.config.patplanSite);
	}

}